import type { AlignerFormData, SelectedTeeth } from '@witmetrics/utils';

export const RELU_UPPER_ARCH = 'RELU_UPPER_ARCH';
export const RELU_LOWER_ARCH = 'RELU_LOWER_ARCH';

export const DEFAULT_ALIGNER_DATA: AlignerFormData = {
  archToTreat: null,
  overjet: null,
  overbite: null,
  spacing: null,
  midline: null,
  posteriorCrossbite: null,
};

export const DEFAULT_SELECTED_TEETH: SelectedTeeth = {
  upperRight: [],
  upperLeft: [],
  lowerRight: [],
  lowerLeft: [],
};
